import { ArrowRight, Award, Bot, Medal, MessagesSquare, MonitorPlay, Network, TrendingUp, Users } from 'lucide-react';
import { PARTNER_BENEFITS, WHY_JOIN } from '../data';
import { Reveal, SectionHead, useApp } from './shared';

const ICONS = [Users, Award, TrendingUp, Network, Medal, MonitorPlay, MessagesSquare, Bot];

export default function WhyJoin() {
  const { openModal } = useApp();

  return (
    <>
      <section id="why" className="tex-dots py-24 md:py-32">
        <div className="mx-auto w-full max-w-7xl px-5 md:px-8">
          <SectionHead
            eyebrow="Why join"
            title={
              <>
                Why You Should <span className="text-lime">Join</span>
              </>
            }
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {WHY_JOIN.map((w, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={w} delay={(i % 4) * 0.07} className="h-full">
                  <div
                    data-testid={`why-join-card-${i}`}
                    className="group h-full rounded-xl border border-line/10 bg-ink-2/50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-lime/50"
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-lime/30 bg-lime/5 transition-all duration-300 group-hover:bg-lime/15">
                      <Icon size={20} strokeWidth={1.6} className="text-lime" />
                    </div>
                    <p className="mt-5 font-display text-sm font-bold leading-snug tracking-tight sm:text-[15px]">
                      {w}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section id="partner-cta" className="px-5 pb-24 md:px-8 md:pb-32">
        <Reveal className="mx-auto w-full max-w-7xl">
          <div
            data-testid="partner-cta-panel"
            className="relative overflow-hidden rounded-3xl border border-lime/25 bg-gradient-to-br from-ink-3 via-ink-2 to-ink p-10 md:p-16"
          >
            <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-lime/15 blur-[120px]" />
            <div className="relative grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-lime">Partner</p>
                <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                  Partner <span className="text-lime">With Us</span>
                </h2>
                <p className="mt-5 max-w-md leading-relaxed text-slate-300">
                  Put your brand at the center of India&apos;s most influential CXO gathering — a full day of
                  curated engagements with the leaders who decide.
                </p>
                <button
                  data-testid="partner-cta-button"
                  onClick={() => openModal('partner')}
                  className="group mt-8 inline-flex items-center gap-3 rounded-full bg-lime px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-ink transition-all duration-300 hover:shadow-[0_0_40px_rgba(153,204,0,0.5)]"
                >
                  Express Interest
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                </button>
              </div>
              <ul className="space-y-5">
                {PARTNER_BENEFITS.map((b, i) => (
                  <li
                    key={i}
                    data-testid={`partner-benefit-${i}`}
                    className="group flex items-start gap-4 border-b border-line/10 pb-5 transition-colors hover:border-lime/40"
                  >
                    <span className="mt-1 font-mono text-[10px] text-lime">0{i + 1}</span>
                    <span className="font-display text-sm font-bold leading-snug tracking-tight text-slate-200 sm:text-base">
                      {b}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
